import {IS_LIXIL_UI} from "../config";
import {getCurrentZIndexes} from "../bvcomponents/appLayout";


export const makeHoveringLayer = (layer, image, layoutType = "Large", canvasDimensions = null, fabricatorData = null) => {

  const zIndexesObject = getCurrentZIndexes();

  // console.log('layer+', layer);
  const withNewBackgrounds = ["bvLook", "kvScene", "Fireplace", "LaundryRoom"].some(visType => document.kvConfig.visualizerType === visType);

  const isBackgroundLayer =
    ((document.kvConfig.visualizerType === "bvScene") && Object.values(zIndexesObject.layouts[layoutType].Background).includes(layer.zIndex))
    || (withNewBackgrounds && layer.zIndex >= 50000);

  // step 1 - create an image from layer // get layerDimensions
  let layerDimensions = zIndexesObject.getLayerDimensions(withNewBackgrounds ? layer : layer.zIndex, layoutType, canvasDimensions);
  // console.log('layerDimensions+', layerDimensions);
  if (!layerDimensions) {
    console.log('layerDimensions not found!', layer);
    // return makeHoveringLayerOld(layer, image)
    layerDimensions = {
      polygonArray: [[0, 0], [canvasDimensions.width, 0], [canvasDimensions.width, canvasDimensions.height], [0, canvasDimensions.height]],
      width: canvasDimensions.width,
      height: canvasDimensions.height
    };
    // return makeHoveringLayerOld(layer, image)
  }

  const width = layer.cropCoords ? layer.cropCoords[2] - layer.cropCoords[0] : layerDimensions.width;
  const height = layer.cropCoords ? layer.cropCoords[3] - layer.cropCoords[1] : layerDimensions.height;

  // step 2 - create for each layer fake canvas
  const fakeCanvas = document.createElement('canvas');
  fakeCanvas.setAttribute('width', `${width}px`);
  fakeCanvas.setAttribute('height', `${height}px`);
  const context2D = fakeCanvas.getContext("2d", { willReadFrequently: true });

  // step 3 - make canvas layer 0.5 transparent
  // if (!backGroundIndexes.includes(layer.zIndex)) { // do it for all layers
    context2D.globalAlpha = fabricatorData && fabricatorData.isAmericanStandard ? 0.75 : 0.5;
  // }

  // step 4 - put layer image on fake canvas
  context2D.clearRect(0, 0, fakeCanvas.width, fakeCanvas.height);
  const x1 = layer.cropCoords ? 0 : layerDimensions.polygonArray[0][0];
  const y1 = layer.cropCoords ? 0 : layerDimensions.polygonArray[0][1];
  context2D.drawImage(image, x1, y1, width, height, 0, 0, width, height);

  // step 5 - create green map for this layer
  let imageData = null
  try {
    imageData = context2D.getImageData(0, 0, width, height);
  } catch (error) {
    console.log("error creating hovering layer", layer, image, layoutType, canvasDimensions, error);
    return null
  }
  // const imageData = context2D.getImageData(300, 400, 300, 400);

  const map = imageData.data;

  let r, g, b, a;

  const multipliers = {
    r: IS_LIXIL_UI ? 0 : 0.2,
    g: 0.7,
    b: IS_LIXIL_UI ? 1 : 0.2,
  }

  for (let p = 0, len = imageData.data.length; p < len; p += 4) {

    r = map[p];
    g = map[p + 1];
    b = map[p + 2];
    a = map[p + 3];

    if (a !== 0 && (r > 2) && (b > 2) && (g > 2)) { // not a background or not dark
      if (fabricatorData && fabricatorData.isAmericanStandard) {
        r = 231;
        g = 0;
        b = 38;
      } else {
        r = r * multipliers.r;
        g = g * multipliers.g;
        b = b * multipliers.b;
      }
      if (g > 255) {
        g = 255;
      }
      map[p] = r;
      map[p + 1] = g;
      map[p + 2] = b;
      map[p + 3] = a;
    } else if (isBackgroundLayer) {
      map[p] = 0;
      map[p + 1] = 0;
      map[p + 2] = 0;
      map[p + 3] = 0;
    }
  }

  // step 6 - put green map on canvas
  context2D.clearRect(0, 0, width, height);
  context2D.putImageData(imageData, 0, 0);

  const greenImage = fakeCanvas.toDataURL();
  const hoveringImage = new Image();
  hoveringImage.crossOrigin = 'Anonymous';
  hoveringImage.layerDimensions = layer.layerDimensions || null;
  hoveringImage.coords = layer.coords || null;
  try {
    hoveringImage.src = greenImage;
  } catch (e) {
    console.log(e, 'Can\'t apply layer Hovering src', greenImage);
  }
  return {
    layer,
    context2D,
    layerDimensions,
    greenImage,
    hoveringImage,
  };
};

export const makeHoveringLayerOld = (layer, image, width = 1620, height = 1080)  => {
  // window.t0 = performance.now();

  // step 1 - create an image from layer // no needed it more, it comes rendered from this.draw() method
  // const img = new Image();
  // img.crossOrigin = "Anonymous";
  // img.src = layer.image;

  // step 2 - create for each layer fake canvas
  const fakeCanvas = document.createElement('canvas');
  fakeCanvas.setAttribute('height', `${height}px`);
  fakeCanvas.setAttribute('width', `${width}px`);
  const context2D = fakeCanvas.getContext("2d", { willReadFrequently: true });

  // step 3 - make canvas layer 0.5 transparent
  context2D.globalAlpha = 0.5;

  // step 4 - put layer image on fake canvas
  context2D.clearRect(0, 0, fakeCanvas.width, fakeCanvas.height);

  if (!(image.complete && image.naturalHeight !== 0)) {
    return {
      layer,
      context2D,
      greenImage: ""
    }
  }

  context2D.drawImage(image, 0, 0);

  // step 5 - create green map for this layer
  const imageData = context2D.getImageData(0, 0, width, height);
  // const imageData = context2D.getImageData(300, 400, 300, 400);

  const map = imageData.data;

  let r, g, b, a;
  for (let p = 0, len = imageData.data.length; p < len; p += 4) {

    r = map[p];
    g = map[p + 1];
    b = map[p + 2];
    a = map[p + 3];

    if (a !== 0) {
      r = r * 0.2;
      b = b * 0.2;
      g = g * 0.7;
      if (g > 255) {
        g = 255;
      }
      map[p] = r;
      map[p + 1] = g;
      map[p + 2] = b;
      map[p + 3] = a;
    }
  }

  // step 6 - put green map on canvas
  context2D.clearRect(0, 0, fakeCanvas.width, fakeCanvas.height);
  context2D.putImageData(imageData, 0, 0);

  // step 7 - set values in reverse order (we need top layers to be hoverable first)
  // window.t1 = performance.now();
  // console.log("Call to doSomething took " + (window.t1 - window.t0) + " milliseconds.");
  return {
    layer,
    context2D,
    greenImage: fakeCanvas.toDataURL()
  };

};
